export default {

    // меню
    'Заявки': 'Заявки',
    Заказы: 'Заказы',
    'Новый заказ': 'Новый заказ',
    'Билеты в музеи': 'Билеты в музеи',
    'Подать график': 'Подать график',
    'Радио/Аудиогид': 'Радио/Аудиогид',
    Архив: 'Архив',
    Отчеты: 'Отчеты',
    Сверка: 'Сверка',
    Оплата: 'Оплата',
    'Оплата Wechat': 'Оплата Wechat',
    'Оплата заявок': 'Оплата заявок',
    'История платежей': 'История платежей',
    'Прайс-лист': 'Прайс-лист',
    'Продление лицензий': 'Продление лицензий',
    'Мои лицензии': 'Мои лицензии',
    Продление: 'Продление',
    Информация: 'Информация',
    Новости: 'Новости',
    Транспорт: 'Транспорт',
    'О компании': 'О компании',
    Договор: 'Договор',
    'Договор оферты': 'Договор оферты',
    'Политика возврата': 'Политика возврата',
    'Поиск по ref, номеру заявки, дате или объекту': 'Поиск по ref, номеру заявки, дате или объекту',
    Настройки: 'Настройки',
    Помощь: 'Помощь',
    'Обратная связь': 'Обратная связь',
    Выйти: 'Выйти',
    'Старая версия сайта': 'Старая версия сайта',
    'ООО «АВАНГАРД ТРАВЕЛ ГРУПП»': 'ООО «АВАНГАРД ТРАВЕЛ ГРУПП»',

    // заказы
    'Нет предстоящих заказов': 'Нет предстоящих заказов',
    'Выберите форму заказа': 'Выберите форму заказа',
    'Заказать билеты в музей': 'Заказать билеты в музей',
    'Заказать Радио/Аудиогиды': 'Заказать Радио/Аудиогиды',
    Заявка: 'Заявка',
    'В обработке': 'В обработке',
    'Подтврждена': 'Подтврждена',
    'Лист ожидания': 'Лист ожидания',
    'Аннулирована': 'Аннулирована',
    'Отклонена': 'Отклонена',
    'Подтвержденное время:': 'Подтвержденное время:',
    'Вход': 'Вход',
    'ПОДРОБНЕЕ': 'ПОДРОБНЕЕ',
    'ИЗМЕНИТЬ': 'ИЗМЕНИТЬ',
    'ГДЕ СОТРУДНИК': 'ГДЕ СОТРУДНИК',
    'АННУЛИРОВАТЬ': 'АННУЛИРОВАТЬ',
    'В АРХИВ': 'В АРХИВ',
    'Сотрудник на объекте': 'Сотрудник на объекте',
    'Сотрудник не на объекте': 'Сотрудник не на объекте',
    'Но вы можете связаться с нами:': 'Но вы можете связаться с нами:',
    'Аннулировать': 'Аннулировать',
    'Хотите аннулировать заявку?': 'Хотите аннулировать заявку?',
    'Аннулированная заявка попадет в архив и восстановить ее будет невозможно': 'Аннулированная заявка попадет в архив и восстановить ее будет невозможно',
    'Отмена': 'Отмена',
    'Дата и время:': 'Дата и время:',
    'Имя гида:': 'Имя гида:',
    'Не заполнено': 'Не заполнено',
    'Телефон гида:': 'Телефон гида:',
    'Пожелания:': 'Пожелания:',
    'Подтвержденное время и вход:': 'Подтвержденное время и вход:',
    'Билеты:': 'Билеты:',
    'Дополнительные услуги:': 'Дополнительные услуги:',
    'Причина отклонения:': 'Причина отклонения:',
    'Информация о группе:': 'Информация о группе:',
    'Доп.услуги:': 'Доп.услуги:',
    'Доп.информация:': 'Доп.информация:',
    'График': 'График',
    'Гид': 'Гид',
    'Заказать': 'Заказать',

    // новый заказ
    'Информация о музее': 'Информация о музее',
    'Выберите категорию группы (РФ или ИГ), музей, дату и время': 'Выберите категорию группы (РФ или ИГ), музей, дату и время',
    'Выберите категорию группы': 'Выберите категорию группы',
    'Выберите музей': 'Выберите музей',
    'Нет заявок за выбранный период': 'Нет заявок за выбранный период',
    'Уведомления': 'Уведомления',
    'Ничего не найдено': 'Ничего не найдено',
    'Поиск': 'Поиск',
    'Все новости': 'Все новости',
    'Уведомлений пока нет': 'Уведомлений пока нет',
    'В списке — только музеи, по которым у вас были заявки за выбранный период': 'В списке — только музеи, по которым у вас были заявки за выбранный период',
    'Выберите объект': 'Выберите объект',
    Далее: 'Далее',
    'Выберите дату': 'Выберите дату',
    'Выберите время': 'Выберите время',
    'Информация о группе': 'Информация о группе',
    'Выберите кол-во билетов': 'Выберите кол-во билетов',
    'Выберите страну': 'Выберите страну',
    Назад: 'Назад',
    'Доп. услуги': 'Доп. услуги',
    'Выберите дополнительные услуги': 'Выберите дополнительные услуги',
    'Кол-во гидов сопровождающих (если нет лицензии)': 'Кол-во гидов сопровождающих (если нет лицензии)',
    'Необходим если у гида нет лицензии в выбранный музей': 'Необходим если у гида нет лицензии в выбранный музей',
    'Доп. информация': 'Доп. информация',
    'Информация о гиде и пожелания': 'Информация о гиде и пожелания',
    'Ref номер (необязательно)': 'Ref номер (необязательно)',
    'Уникальный номер группы / вспомогательный номер для ваших целей': 'Уникальный номер группы / вспомогательный номер для ваших целей',
    'Имя гида': 'Имя гида',
    'Телефон гида': 'Телефон гида',
    Пожелания: 'Пожелания',
    'В поле "Пожелания" укажите:': 'В поле "Пожелания" укажите:',
    'адрес и время получения': 'адрес и время получения',
    'адрес и приблизительное время возврата оборудования': 'адрес и приблизительное время возврата оборудования',
    Отправить: 'Отправить',
    'Пожалуйста, ожидайте': 'Пожалуйста, ожидайте',
    'Успешно!': 'Успешно!',
    'Заказ создан': 'Заказ создан',
    'Ошибка:': 'Ошибка:',
    Ок: 'Ок',
    'Кол-во взрослых': 'Кол-во взрослых',
    'Кол-во детей': 'Кол-во детей',
    'итого:': 'итого:',
    'чел. (надо': 'чел. (надо',
    'экскурс.обсл.)': 'экскурс.обсл.)',
    'гид. или сопровожд.)': 'гид. или сопровожд.)',
    'Радиогид': 'Радиогид',
    'Экскурсия ведется лицензионным гидом': 'Экскурсия ведется лицензионным гидом',
    'Аудиогид': 'Аудиогид',
    'Экскурсия ведется при помощи технических средств на языке группы': 'Экскурсия ведется при помощи технических средств на языке группы',
    'Кол-во гидов с лицензией': 'Кол-во гидов с лицензией',
    'Кол-во сопровождающих': 'Кол-во сопровождающих',
    'Удалить': 'Удалить',
    'Отправить заказ': 'Отправить заказ',
    'Добавить группу': 'Добавить группу',
    'Группа': 'Группа',

    // архив
    'Номер заявки или ref': 'Номер заявки или ref',
    Объект: 'Объект',
    'Номер заявки': 'Номер заявки',
    Все: 'Все',
    'Дата посещения с': 'Дата посещения с',
    'Дата посещения по': 'Дата посещения по',
    Найти: 'Найти',
    'Заказов согласно фильтру не найдено': 'Заказов согласно фильтру не найдено',
    Ошибка: 'Ошибка',
    'Любой номер': 'Любой номер',

    // сверка
    Сформировать: 'Сформировать',
    'Файл сверки': 'Файл сверки',
    'Для скачивания сформированного файла сверки нажмите на конпку "Скачать".': 'Для скачивания сформированного файла сверки нажмите на конпку "Скачать".',
    'Скачать': 'Скачать',

    // оплата заявок
    'Оплатить заявки': 'Оплатить заявки',
    'Номера ваучеров или заявок для оплаты (через запятую)': 'Номера ваучеров или заявок для оплаты (через запятую)',
    'Введите номера ваучеров или заявок для оплаты': 'Введите номера ваучеров или заявок для оплаты',
    'ФИО или название организации': 'ФИО или название организации',
    'Введите ФИО или название организации': 'Введите ФИО или название организации',
    Email: 'Email',
    'Введите Email': 'Введите Email',
    'Сумма к оплате': 'Сумма к оплате',
    'Введите сумму к оплате': 'Введите сумму к оплате',
    'Согласен с договором оферты': 'Я согласен с договором оферты',
    'Перейти к оплате': 'Перейти к оплате',
    'Подождите,': 'Подождите,',
    'принимаем': 'принимаем',
    'оплату...': 'оплату...',
    'Заказ успешно оплачен!': 'Заказ успешно оплачен!',
    'Ваш заказ': 'Ваш заказ',
    'успешно оплачен. Спасибо за покупку!': 'успешно оплачен. Спасибо за покупку!',
    'Что-то пошло не так!': 'Что-то пошло не так!',
    'При оплате заказа': 'При оплате заказа',
    'произошла ошибка!': 'произошла ошибка!',
    'Cчет успешно сформирован!': 'Cчет успешно сформирован!',
    'Вы можете открыть его нажав кнопку ниже': 'Вы можете открыть его нажав кнопку ниже',
    'Открыть счет': 'Открыть счет',
    'Физическим лицам': 'Физическим лицам',
    'Юридическим лицам': 'Юридическим лицам',
    'Для формирования счета на оплату введите номера ваучеров или заказов, укажите реквизиты компании и точную сумму:': 'Для формирования счета на оплату введите номера ваучеров или заказов, укажите реквизиты компании и точную сумму:',
    'Для оплаты введите номера ваучеров или заявок и укажите точную сумму для оплаты:': 'Для оплаты введите номера ваучеров или заявок и укажите точную сумму для оплаты:',
    'Название организации': 'Название организации',
    'Юридический адрес': 'Юридический адрес',
    'Сформировать счет': 'Сформировать счет',
    'Расчетный счет': 'Расчетный счет',
    'ИНН': 'ИНН',
    'КПП': 'КПП',
    'Банк': 'Банк',
    'Полное название банка (для формирования акта). Например: ': 'Полное название банка (для формирования акта). Например: ',
    'БИК Банка': 'БИК Банка',
    'Корреспондентский счет': 'Корреспондентский счет',

    // история платежей
    'Номер платежа': 'Номер платежа',
    Ваучеры: 'Ваучеры',
    'Способ оплаты': 'Способ оплаты',
    'Время и дата оплаты': 'Время и дата оплаты',
    Сумма: 'Сумма',
    Статус: 'Статус',
    'Платежи отсутствуют': 'Платежи отсутствуют',

    // прайс-лист
    'Прайс-лист для иностранных групп': 'Прайс-лист для иностранных групп',
    'Актуальный файл с ценами для иностранных групп.': 'Актуальный файл с ценами для иностранных групп.',
    Открыть: 'Открыть',
    'Прайс-лист для российских групп': 'Прайс-лист для российских групп',
    'Актуальный файл с ценами для российских групп.': 'Актуальный файл с ценами для российских групп.',

    // лицензии
    'Добавить лицензию': 'Добавить лицензию',
    'В настоящий момент нет сохраненных лицензий, вы можете добавить их.': 'В настоящий момент нет сохраненных лицензий, вы можете добавить их.',
    'Добавить': 'Добавить',
    'Музей': 'Музей',
    'Номер лицензии': 'Номер лицензии',
    'Стаж (лет)': 'Стаж (лет)',
    'Дата окончания': 'Дата окончания',
    'Основной язык': 'Основной язык',
    'Дополнительные языки': 'Дополнительные языки',

    // о компании
    'ИНН:7841027155': 'ИНН:7841027155',
    'КПП: 784101001': 'КПП: 784101001',
    'ОГРН: 1157847276003': 'ОГРН: 1157847276003',
    'ОКПО: 25885413': 'ОКПО: 25885413',
    'Расчетный счет: 40702810603260000188': 'Расчетный счет: 40702810603260000188',
    'Банк: Филиал "Центральный" Банка ВТБ (ПАО)': 'Банк: Филиал "Центральный" Банка ВТБ (ПАО)',
    'БИК: 044525411': 'БИК: 044525411',
    'Корр. счет: 30101810145250000411': 'Корр. счет: 30101810145250000411',
    'Юридический адрес: 191186, Санкт-Петербург г, вн.тер. г. муниципальный округ Дворцовый округ, наб Канала Грибоедова, д. 5, литера Е, помещ. Ч.ПОМ. 19-Н ОФ.405': 'Юридический адрес: 191186, Санкт-Петербург г, вн.тер. г. муниципальный округ Дворцовый округ, наб Канала Грибоедова, д. 5, литера Е, помещ. Ч.ПОМ. 19-Н ОФ.405',
    'Email: info@avangard-travel.ru': 'Email: info@avangard-travel.ru',
    'Телефон: (812) 640-02-28': 'Телефон: (812) 640-02-28',

    // договор
    'Вы можете посмотреть договор с ООО "Авангард Травел Групп".': 'Вы можете посмотреть договор с ООО "Авангард Травел Групп". ',

    // договор оферты
    'Вы можете посмотреть договор оферты с ООО "Авангард Травел Групп".': 'Вы можете посмотреть договор оферты с ООО "Авангард Травел Групп".',

    // политика возврата
    'Вы можете посмотреть политику возврата.': 'Вы можете посмотреть политику возврата.',

    // настройки
    'Имя:': 'Имя:',
    'Телефон:': 'Телефон:',
    'Страна:': 'Страна:',
    'Информация о гиде': 'Информация о гиде',
    'Заполните информацию и подавайте заявки еще быстрее': 'Заполните информацию и подавайте заявки еще быстрее',
    Имя: 'Имя',
    Телефон: 'Телефон',
    'Выберите страницу': 'Выберите страницу',
    'Использовать в заказе?': 'Использовать в заказе?',
    Сохранить: 'Сохранить',
    'Являетесь ли вы туристической фирмой / юридическим лицом': 'Являетесь ли вы туристической фирмой / юридическим лицом',
    'Юридическое лицо': 'Юридическое лицо',
    'Для выставления счетов': 'Для выставления счетов',

    // форма логина
    Логин: 'Логин',
    Пароль: 'Пароль',
    Войти: 'Войти',
    'Выберите язык': 'Выберите язык',
    'У вас нет аккаунта?': 'У вас нет аккаунта?',
    'Зарегистрироваться': 'Зарегистрироваться',
    'Добро пожаловать!': 'Добро пожаловать!',
    'Будем рады видеть вас среди наших клиентов! Пожалуйста, уделите немного времени на заполнение формы ниже. Вскоре мы отправим вам все необходимые инструкции на указанный адрес электронной почты.': 'Будем рады видеть вас среди наших клиентов! Пожалуйста, уделите немного времени на заполнение формы ниже. Вскоре мы отправим вам все необходимые инструкции на указанный адрес электронной почты.',
    'Фамилия': 'Фамилия',
    'Физ.лицо': 'Физ.лицо',
    'Юр.лицо': 'Юр.лицо',
    'Отчество': 'Отчество',
    'У вас есть аккаунт?': 'У вас есть аккаунт?',
    'Название фирмы': 'Название фирмы',
    'БИК': 'БИК',
    'ФИО контактного лица': 'ФИО контактного лица',
    'Заявка принята!': 'Заявка принята!',
    'Спасибо за вашу заявку! В ближайшее время на указанный вами адрес электронной почты мы отправим все необходимые инструкции.': 'Спасибо за вашу заявку! В ближайшее время на указанный вами адрес электронной почты мы отправим все необходимые инструкции.',
    'Закрыть': 'Закрыть',

    // уведомление
    'Теперь можно оплатить заявки онлайн, включая оплату от юридических лиц!': 'Теперь можно оплатить заявки онлайн, включая оплату от юридических лиц!',
    'Мы рады сообщить, что теперь вы можете оплатить заявки на нашем сайте, используя банковскую карту или QR-код системы быстрых платежей. Вдобавок к этому, мы расширили наши возможности и теперь доступна оплата и для юридических лиц. Юридические лица могут самостоятельно генерировать счета для оплаты.': 'Мы рады сообщить, что теперь вы можете оплатить заявки на нашем сайте, используя банковскую карту или QR-код системы быстрых платежей. Вдобавок к этому, мы расширили наши возможности и теперь доступна оплата и для юридических лиц. Юридические лица могут самостоятельно генерировать счета для оплаты.',
    'Никаких задержек и лишних хлопот - оплата проходит мгновенно. Перейдите в раздел "Оплата заявок" и оплачивайте свои заявки быстро и удобно! Наши новые возможности сделают процесс ещё более удобным и эффективным.': 'Никаких задержек и лишних хлопот - оплата проходит мгновенно. Перейдите в раздел "Оплата заявок" и оплачивайте свои заявки быстро и удобно! Наши новые возможности сделают процесс ещё более удобным и эффективным.',

    // помощь
    'У вас есть вопросы?': 'У вас есть вопросы?',
    'Если вы не можете найти ответ на вопрос, вы всегда можете связаться с нами. Мы ответим вам в ближайшее время!': 'Если вы не можете найти ответ на вопрос, вы всегда можете связаться с нами. Мы ответим вам в ближайшее время!',
    'Мы всегда рады помочь!': 'Мы всегда рады помочь!',
    'Лучший способ получить ответ быстрее!': 'Лучший способ получить ответ быстрее!',

    // в разработе
    'Готовимся к запуску. Новая функция в пути! 🚀': 'Готовимся к запуску. Новая функция в пути! 🚀',
    'Мы активно работаем над новой функцией для вас.': 'Мы активно работаем над новой функцией для вас.',
    'Будьте в курсе предстоящих обновлений!': 'Будьте в курсе предстоящих обновлений!',

    // Обратная связь
    'Мы всегда рады услышать вас!': 'Мы всегда рады услышать вас!',
    'Наши усилия направлены на то, чтобы сделать систему подачи заявок максимально удобной и эффективной для вас. Ваше мнение и предложения играют ключевую роль в этом процессе. Не стесняйтесь делиться своими мыслями, идеями, а также сообщать нам обо всех замеченных ошибках или проблемах в работе системы. Вместе мы сделаем систему подачи заявок лучше!': 'Наши усилия направлены на то, чтобы сделать систему подачи заявок максимально удобной и эффективной для вас. Ваше мнение и предложения играют ключевую роль в этом процессе. Не стесняйтесь делиться своими мыслями, идеями, а также сообщать нам обо всех замеченных ошибках или проблемах в работе системы. Вместе мы сделаем систему подачи заявок лучше!',
    'Как к вам обращаться?': 'Как к вам обращаться?',
    'Email для обратной связи': 'Email для обратной связи',
    'Опишите ваше предложение, жалобу или замеченную ошибку': 'Опишите ваше предложение, жалобу или замеченную ошибку',
    'Мы используем файлы cookie, чтобы сайт работал и был удобнее. Оставаясь на сайте, вы соглашаетесь на их использование.': 'Мы используем файлы cookie, чтобы сайт работал и был удобнее. Оставаясь на сайте, вы соглашаетесь на их использование.',
    'Хорошо': 'Хорошо',
    'Подача графика на {month} закрывается {deadline}.': 'Подача графика на {month} закрывается {deadline}.',
    'Россия': 'Россия',

    // оплата лицензий
    'Оплата продления': 'Оплата продления',
    'Оплатить': 'Оплатить',
    'К заказам': 'К заказам',
    'Повторить': 'Повторить',
    'Выбор лицензий': 'Выбор лицензий',
    'Выберите одну или несколько лицензий для оплаты': 'Выберите одну или несколько лицензий для оплаты',
    'Сезон продления: приём заявок с {start} по {finish}': 'Сезон продления: приём заявок с {start} по {finish}',
    'Выберите лицензии': 'Выберите лицензии',
    'Нет лицензий для оплаты': 'Нет лицензий для оплаты',
    'Итого к оплате': 'Итого к оплате',
    'Плательщик': 'Плательщик',
    'ФИО и email, на который придёт чек': 'ФИО и email, на который придёт чек',
    'Проверьте список лицензий и перейдите к оплате': 'Проверьте список лицензий и перейдите к оплате',
    'Лицензия № {no}': 'Лицензия № {no}',
    'После оплаты менеджер получит уведомление и отметит оплату. Чек придёт на указанный email.': 'После оплаты менеджер получит уведомление и отметит оплату. Чек придёт на указанный email.',
    'Продление уже оплачено': 'Продление уже оплачено',
    'Оплачено на сайте, ждёт подтверждения менеджера': 'Оплачено на сайте, ждёт подтверждения менеджера',
    'Оплата лицензий пока недоступна.': 'Оплата лицензий пока недоступна.',
    'Цены на лицензии ещё не опубликованы. Попробуйте позже или свяжитесь с менеджером.': 'Цены на лицензии ещё не опубликованы. Попробуйте позже или свяжитесь с менеджером.',
    'Не удалось получить список лицензий. Попробуйте ещё раз.': 'Не удалось получить список лицензий. Попробуйте ещё раз.',
    'Не удалось создать счёт на оплату. Попробуйте ещё раз.': 'Не удалось создать счёт на оплату. Попробуйте ещё раз.',
    'Список лицензий или цены изменились. Обновите страницу и выберите лицензии заново.': 'Список лицензий или цены изменились. Обновите страницу и выберите лицензии заново.',
    'Введите email': 'Введите email',
    'Введите ваш email': 'Введите ваш email',
    'Продление этой лицензии сейчас закрыто': 'Продление этой лицензии сейчас закрыто',
    'Укажите язык лицензии в разделе «Мои лицензии»': 'Укажите язык лицензии в разделе «Мои лицензии»',
    'Заявка на продление подана': 'Заявка на продление подана',
    'Заявка на продление будет подана автоматически': 'Заявка на продление будет подана автоматически',
    'Заявку на продление оформит менеджер': 'Заявку на продление оформит менеджер',
    'Добавьте свои лицензии в раздел «Мои лицензии», и заявки на продление будут подаваться автоматически.': 'Добавьте свои лицензии в раздел «Мои лицензии», и заявки на продление будут подаваться автоматически.',
    'Консультационные услуги (лицензии)': 'Консультационные услуги (лицензии)',
    'Продление или первичное получение, затем музей': 'Продление или первичное получение, затем музей',
    'Первичное получение': 'Первичное получение',
    'первичное получение': 'первичное получение',
    'Оплата в офисе': 'Оплата в офисе',
    'Итого к оплате на сайте': 'Итого к оплате на сайте',
    'ФИО для договора, телефон и email, на который придёт чек': 'ФИО для договора, телефон и email, на который придёт чек',
    'ФИО': 'ФИО',
    'Фамилия Имя Отчество': 'Фамилия Имя Отчество',
    'Введите ФИО полностью': 'Введите ФИО полностью',
    'Контактный телефон': 'Контактный телефон',
    'Введите корректный телефон': 'Введите корректный телефон',
    'Договор и оплата': 'Договор и оплата',
    'Проверьте список, подтвердите договор и перейдите к оплате': 'Проверьте список, подтвердите договор и перейдите к оплате',
    'Заявки на продление поданы.': 'Заявки на продление поданы.',
    'Оплата этих лицензий производится в офисе. Для справок свяжитесь с менеджером по телефону {phone}.': 'Оплата этих лицензий производится в офисе. Для справок свяжитесь с менеджером по телефону {phone}.',
    'Договор оказания услуг': 'Договор оказания услуг',
    'Не удалось получить текст договора. Попробуйте ещё раз.': 'Не удалось получить текст договора. Попробуйте ещё раз.',
    'Я принимаю условия договора возмездного оказания услуг': 'Я согласен с условиями договора возмездного оказания услуг',
    'Подать заявки': 'Подать заявки',
    'Выбор группы откроется после оплаты продления.': 'Выбор группы откроется после оплаты продления.',
    'Оплатить продление': 'Оплатить продление',
    'Продление оплачено на сайте.': 'Продление оплачено на сайте.',
    'Не удалось записаться в группу. Попробуйте ещё раз.': 'Не удалось записаться в группу. Попробуйте ещё раз.',
    'Выбрать группу': 'Выбрать группу',
    'Теперь можно выбрать группу для занятий: она появится в карточке музея на странице «Продление», как только менеджер назначит даты.': 'Теперь можно выбрать группу для занятий: она появится в карточке музея на странице «Продление», как только менеджер назначит даты.',
    'Тестовый режим': 'Тестовый режим',
    'Раздел проверяется, оплачивать лицензии через сайт пока не нужно.': 'Раздел проверяется, оплачивать лицензии через сайт пока не нужно.',
    'истекла': 'истекла',
    'Не удалось удалить лицензию. Попробуйте ещё раз.': 'Не удалось удалить лицензию. Попробуйте ещё раз.',
    'Не удалось добавить лицензию. Попробуйте ещё раз.': 'Не удалось добавить лицензию. Попробуйте ещё раз.',
    'Расписание занятий': 'Расписание занятий',
    'Расписание занятий пока не опубликовано.': 'Расписание занятий пока не опубликовано.',
    'Расписание занятий появится после записи.': 'Расписание занятий появится после записи.',
    'Стоимость занятий': 'Стоимость занятий',
    'Записаться на продление': 'Записаться на продление',
    'Оплатить занятия': 'Оплатить занятия',
    'Выбрать дату занятий': 'Выбрать дату занятий',
    'Подать заявку на продление: {museum}? После этого станет видно расписание занятий.': 'Подать заявку на продление: {museum}? После этого станет видно расписание занятий.',
    'Продление по этому музею сейчас закрыто.': 'Продление по этому музею сейчас закрыто.',
    'Укажите в лицензии язык: без него заявку не принять. Это можно сделать через «Изменить».': 'Укажите в лицензии язык: без него заявку не принять. Это можно сделать через «Изменить».',
    'Лицензия продлена.': 'Лицензия продлена.',
    'Заявка на продление подана.': 'Заявка на продление подана.',
    'Занятия оплачены.': 'Занятия оплачены.',
    'Занятия оплачены на сайте, менеджер подтвердит оплату.': 'Занятия оплачены на сайте, менеджер подтвердит оплату.',
    'Вы записаны на занятия: {group}.': 'Вы записаны на занятия: {group}.',
    'Не удалось подать заявку. Попробуйте ещё раз.': 'Не удалось подать заявку. Попробуйте ещё раз.',
    'Занятия оплачены. Выберите дату занятий в карточке: {museums}.': 'Занятия оплачены. Выберите дату занятий в карточке: {museums}.',
    'Укажите язык лицензии на странице «Продление лицензий»': 'Укажите язык лицензии на странице «Продление лицензий»',
    'Сначала добавьте лицензию на странице «Продление лицензий»': 'Сначала добавьте лицензию на странице «Продление лицензий»',
    'Оплата возвращена, можно оплатить заново': 'Оплата возвращена, можно оплатить заново',
    'свободно {free} из {limit}': 'свободно {free} из {limit}',
    'мест нет': 'мест нет',
    'Добавьте свои лицензии на странице «Продление лицензий», и заявки на продление будут подаваться автоматически.': 'Добавьте свои лицензии на странице «Продление лицензий», и заявки на продление будут подаваться автоматически.',
    'Теперь можно выбрать дату занятий по расписанию: откройте карточку лицензии на странице «Продление лицензий».': 'Теперь можно выбрать дату занятий по расписанию: откройте карточку лицензии на странице «Продление лицензий».',
    'Лицензии': 'Лицензии',
    'Подать заявку': 'Подать заявку',
    'Выбрать': 'Выбрать',
    'Стоимость пока не указана.': 'Стоимость пока не указана.',
    'Лицензии на этот музей нет в кабинете. Добавьте её, чтобы записаться на продление и оплатить занятия.': 'Лицензии на этот музей нет в кабинете. Добавьте её, чтобы записаться на продление и оплатить занятия.',
    'Музеи, где у вас нет лицензии': 'Музеи, где у вас нет лицензии',
    'С окончания срока действия лицензии прошло 3 года. Просьба обратиться к менеджеру за консультацией.': 'С окончания срока действия лицензии прошло 3 года. Просьба обратиться к менеджеру за консультацией.',
    'Прошло три года после окончания лицензии — нужно первичное обучение': 'Лицензия истекла больше трёх лет назад — только первичное обучение',
    'Просим вас вписать ФИО полностью и кириллицей: это нужно для соблюдения законодательства РФ.': 'Просим вас вписать ФИО полностью и кириллицей: это нужно для соблюдения законодательства РФ.',
    'Введите ФИО кириллицей — допустимы только буквы, пробел и дефис': 'Введите ФИО кириллицей — допустимы только буквы, пробел и дефис',
    'Оплатите занятия и после этого выберите дату и время.': 'Оплатите занятия и после этого выберите дату и время.',
    'Выбрать дату и время занятий можно будет после подтверждения менеджера.': 'Выбрать дату и время занятий можно будет после подтверждения менеджера.',
    'Поиск по лицензиям': 'Поиск по лицензиям',
    'Музей или номер лицензии': 'Музей или номер лицензии',
    'Договоры оказания услуг': 'Договоры оказания услуг',
    'Договор на продление': 'Договор на продление',
    'Договор на первичное обучение': 'Договор на первичное обучение',
    'Я принимаю условия договоров возмездного оказания услуг': 'Я согласен с условиями договоров возмездного оказания услуг',
    'Email:': 'Email:',
    'После оплаты договор сохранится в «Настройках» и в «Истории платежей»: его можно открыть и скачать в PDF.': 'После оплаты договор сохранится в «Настройках» и в «Истории платежей»: его можно открыть и скачать в PDF.',
    'После оплаты договоры сохранятся в «Настройках» и в «Истории платежей»: их можно открыть и скачать в PDF.': 'После оплаты договоры сохранятся в «Настройках» и в «Истории платежей»: их можно открыть и скачать в PDF.',
    'Договоры оказания услуг, которые вы подписали при оплате лицензий. Их можно открыть и скачать в любой момент.': 'Договоры оказания услуг, которые вы подписали при оплате лицензий. Их можно открыть и скачать в любой момент.',
    'от {date}, платёж № {payment}': 'от {date}, платёж № {payment}',
    'оплата возвращена': 'оплата возвращена',
    'Скачать PDF': 'Скачать PDF',
    'Вы согласились с условиями договора и подписали его {date} в {time}, отметив «{label}».': 'Вы согласились с условиями договора и подписали его {date} в {time}, отметив «{label}».',
    'Не удалось получить договор. Попробуйте ещё раз.': 'Не удалось получить договор. Попробуйте ещё раз.',

    // получение лицензий (правка начальника 02.10.2026)
    'Получение лицензий': 'Получение лицензий',
    'Можно оплатить': 'Можно оплатить',
    'Отметьте музеи и отправьте заявку.': 'Отметьте музеи и отправьте заявку.',
    'Дождитесь даты обучения — она появится здесь.': 'Дождитесь даты обучения — она появится здесь.',
    'Выберите дату и оплатите обучение.': 'Выберите дату и оплатите обучение.',
    'Приём заявок с {start} по {finish}': 'Приём заявок с {start} по {finish}',
    'Получение лицензий сейчас недоступно.': 'Получение лицензий сейчас недоступно.',
    'Мои заявки': 'Мои заявки',
    'Новая заявка': 'Новая заявка',
    'Стоимость обучения': 'Стоимость обучения',
    'Приём заявок сейчас закрыт.': 'Приём заявок сейчас закрыт.',
    'Отправить заявку': 'Отправить заявку',
    'Заявка отправлена: {museums}. Когда появится дата обучения, вы сможете выбрать её и оплатить.': 'Заявка отправлена: {museums}. Когда появится дата обучения, вы сможете выбрать её и оплатить.',
    'Заявки отправлены: {museums}. Когда появится дата обучения, вы сможете выбрать её и оплатить.': 'Заявки отправлены: {museums}. Когда появится дата обучения, вы сможете выбрать её и оплатить.',
    'Заявка отправлена: {museums}. Дата обучения уже есть — выберите её в «Моих заявках» и оплатите.': 'Заявка отправлена: {museums}. Дата обучения уже есть — выберите её в «Моих заявках» и оплатите.',
    'Заявки отправлены: {museums}. Дата обучения уже есть — выберите её в «Моих заявках» и оплатите.': 'Заявки отправлены: {museums}. Дата обучения уже есть — выберите её в «Моих заявках» и оплатите.',
    'Не удалось получить список заявок. Попробуйте ещё раз.': 'Не удалось получить список заявок. Попробуйте ещё раз.',
    'Язык: {langs}': 'Язык: {langs}',
    'Языки: {langs}': 'Языки: {langs}',
    'Заявка подана. Дата обучения пока не назначена. Когда она появится, вы сможете выбрать дату и оплатить обучение.': 'Заявка подана. Дата обучения пока не назначена. Когда она появится, вы сможете выбрать дату и оплатить обучение.',
    'Заявка подана. Выберите дату обучения и оплатите.': 'Заявка подана. Выберите дату обучения и оплатите.',
    'Заявка подана. Дата обучения: {group}.': 'Заявка подана. Дата обучения: {group}.',
    'Заявка подана.': 'Заявка подана.',
    'Дата обучения': 'Дата обучения',
    'Дата обучения: {group}': 'Дата обучения: {group}',
    'Даты обучения': 'Даты обучения',
    'Оплата этого обучения производится в офисе. Для справок свяжитесь с менеджером по телефону {phone}.': 'Оплата этого обучения производится в офисе. Для справок свяжитесь с менеджером по телефону {phone}.',
    'Заявка подана. Стоимость обучения пока не указана — оплата откроется позже.': 'Заявка подана. Стоимость обучения пока не указана — оплата откроется позже.',
    'Обучение оплачено. Записываем вас на {date}. Если запись не появится — позвоните менеджеру: {phone}.': 'Обучение оплачено. Записываем вас на {date}. Если запись не появится — позвоните менеджеру: {phone}.',
    'Обучение оплачено.': 'Обучение оплачено.',
    'Обучение оплачено. Дату обучения сообщит менеджер.': 'Обучение оплачено. Дату обучения сообщит менеджер.',
    'Записать вас на {date} не получилось: {reason}': 'Записать вас на {date} не получилось: {reason}',
    'Выберите другую дату.': 'Выберите другую дату.',
    'Дату обучения сообщит менеджер: {phone}.': 'Дату обучения сообщит менеджер: {phone}.',
    'Обучение оплачено. Вы записаны: {group}.': 'Обучение оплачено. Вы записаны: {group}.',
    'Обучение пройдено.': 'Обучение пройдено.',
    'Лицензия № {no}, действует до {date}.': 'Лицензия № {no}, действует до {date}.',
    'Оплата на сайте пока недоступна. Свяжитесь с менеджером: {phone}.': 'Оплата на сайте пока недоступна. Свяжитесь с менеджером: {phone}.',
    'Изменить языки или отменить заявку можно через менеджера: {phone}.': 'Изменить языки или отменить заявку можно через менеджера: {phone}.',
    'Место в группе закрепляется после оплаты.': 'Место в группе закрепляется после оплаты.',
    'Выбрать дату': 'Выбрать дату',
    'Оплата обучения': 'Оплата обучения',
    'Получаете лицензию впервые?': 'Получаете лицензию впервые?',
    'Вам в раздел «Получение лицензий»': 'Вам в раздел «Получение лицензий»',
    'К заявкам': 'К заявкам',
    'Обучение и дата': 'Обучение и дата',
    'Музей и дата обучения': 'Музей и дата обучения',
    'Музеи, по которым продлеваете лицензию': 'Музеи, по которым продлеваете лицензию',
    'Оплата обучения на сайте пока недоступна.': 'Оплата обучения на сайте пока недоступна.',
    'Оплачивать пока нечего. Оплата откроется после заявки, когда появится дата обучения.': 'Оплачивать пока нечего. Оплата откроется после заявки, когда появится дата обучения.',
    'Дата обучения ещё не назначена': 'Дата обучения ещё не назначена',
    'Выбранная дата обучения больше недоступна. Выберите дату заново.': 'Выбранная дата обучения больше недоступна. Выберите дату заново.',
    'Обучение оплачено. Запись на выбранную дату появится на странице «Получение лицензий».': 'Обучение оплачено. Запись на выбранную дату появится на странице «Получение лицензий».',
    'К моим заявкам': 'К моим заявкам',
    'К оплате продления': 'К оплате продления',
    'Появилась дата обучения: {museums}. Можно выбрать дату и оплатить.': 'Появилась дата обучения: {museums}. Можно выбрать дату и оплатить.',
    'Обучение оплачено, выберите дату: {museums}.': 'Обучение оплачено, выберите дату: {museums}.',
    'Перейти': 'Перейти',
    'Перейти к получению лицензии': 'Перейти к получению лицензии',
    'Не удалось получить список языков.': 'Не удалось получить список языков.',
    'Дата обучения прошла.': 'Дата обучения прошла.',
    'Лицензия по этому музею у вас уже есть. Обратитесь к менеджеру.': 'Лицензия по этому музею у вас уже есть. Обратитесь к менеджеру.',
    'Заявки отправлены: {museums}. Дата обучения уже есть: {dated} — выберите её в «Моих заявках» и оплатите.': 'Заявки отправлены: {museums}. Дата обучения уже есть: {dated} — выберите её в «Моих заявках» и оплатите.',
    'Выберите дату обучения по каждому музею.': 'Выберите дату обучения по каждому музею.',
    'Система заявок сейчас не отвечает. Попробуйте через минуту.': 'Система заявок сейчас не отвечает. Попробуйте через минуту.',
    'Подтвердите договор оказания услуг.': 'Подтвердите договор оказания услуг.',
    'Лицензия не указана.': 'Лицензия не указана.',
    'Лицензия не найдена.': 'Лицензия не найдена.',
    'Выберите хотя бы одну лицензию.': 'Выберите хотя бы одну лицензию.',
    'Введите ФИО кириллицей — допустимы только буквы, пробел и дефис.': 'Введите ФИО кириллицей — допустимы только буквы, пробел и дефис.',
    'Не выбран музей.': 'Не выбран музей.',
    'Выберите язык: без него заявку на обучение не примут.': 'Выберите язык: без него заявку на обучение не примут.',
    'Так записаться можно только на первичное обучение.': 'Так записаться можно только на первичное обучение.',
    'Выбор даты откроется после оплаты обучения.': 'Выбор даты откроется после оплаты обучения.',
    'Введите ФИО полностью.': 'Введите ФИО полностью.',
    'Введите корректный телефон.': 'Введите корректный телефон.',
    'Введите корректный email.': 'Введите корректный email.',
    'Система заявок отклонила запрос. Попробуйте ещё раз или свяжитесь с оператором.': 'Система заявок отклонила запрос. Попробуйте ещё раз или свяжитесь с оператором.',
    'Первичное получение, продление': 'Первичное получение, продление',
    'Мои договоры': 'Мои договоры',
    'Подписанных договоров пока нет. Они появятся здесь после оплаты продления или обучения на сайте.': 'Подписанных договоров пока нет. Они появятся здесь после оплаты продления или обучения на сайте.',
    'Здесь можно заказать технические средства ведения экскурсий': 'Здесь можно заказать технические средства ведения экскурсий',

    // Прайс-лист с ценами (09.10.2026)
    'Ваши цены': 'Ваши цены',
    'Персональный прайс-лист': 'Персональный прайс-лист',
    'Общий прайс-лист': 'Общий прайс-лист',
    'действует с': 'действует с',
    'Объект': 'Объект',
    'Основная цена': 'Основная цена',
    'Льготная цена': 'Льготная цена',
    'Стоимость по прайс-листу:': 'Стоимость по прайс-листу:',
    'без учёта:': 'без учёта:',

    // Прайс-листы по категориям групп (12.10.2026)
    'Российские туристы': 'Российские туристы',
    'Иностранные туристы': 'Иностранные туристы',
    'Китайские туристы': 'Китайские туристы',
    'Школьная группа': 'Школьная группа',
    'Школьные группы': 'Школьные группы',
    'Основная': 'Основная',
    'Льготная': 'Льготная',
    'За группу': 'За группу',
    'Группа до {n} чел.': 'Группа до {n} чел.',
    'Экскурсионное обслуживание': 'Экскурсионное обслуживание',
    'Обслуживание до {n} чел.': 'Обслуживание до {n} чел.',
    'ЭО': 'ЭО',
    'Экскурсионное обслуживание, за одно': 'Экскурсионное обслуживание, за одно',
    'экскурсионное обслуживание': 'экскурсионное обслуживание',
    'VIP': 'VIP',
    'за группу': 'за группу',
    'Нажмите на заголовок, чтобы раскрыть цены, на название музея — его объекты': 'Нажмите на заголовок, чтобы раскрыть цены, на название музея — его объекты',
    'ШКОЛЬНАЯ': 'ШКОЛЬНАЯ',
    'Цена за группу': 'Цена за группу',
    'до {n} чел.': 'до {n} чел.',
    'Услуги в заявке в музей': 'Услуги в заявке в музей',
    'за человека': 'за человека',
    'за доставку': 'за доставку',
    'Калькулятор цен': 'Калькулятор цен',
    'Выберите музей, объект и количество билетов — стоимость посчитается по вашему прайс-листу': 'Выберите музей, объект и количество билетов — стоимость посчитается по вашему прайс-листу',
    'Дата нужна, чтобы взять прайс-лист, действующий на день посещения': 'Дата нужна, чтобы взять прайс-лист, действующий на день посещения',
    'При группе от {n} человек требуется радиогид': 'При группе от {n} человек требуется радиогид',
    'Стоимость': 'Стоимость',
    'Выберите музей и объект — расчёт появится здесь': 'Выберите музей и объект — расчёт появится здесь',
    'Укажите количество билетов': 'Укажите количество билетов',
    'Считаем…': 'Считаем…',
    'Для этого объекта цены в прайс-листе нет. Сумму рассчитает менеджер после подачи заявки.': 'Для этого объекта цены в прайс-листе нет. Сумму рассчитает менеджер после подачи заявки.',
    'Расчёт недоступен: войдите в кабинет заново': 'Расчёт недоступен: войдите в кабинет заново',
    'Итого': 'Итого',
    'У этих услуг нет цены в прайс-листе — её уточнит менеджер.': 'У этих услуг нет цены в прайс-листе — её уточнит менеджер.',
    'Основные билеты': 'Основные билеты',
    'Льготные билеты': 'Льготные билеты',
    '{n} чел.': '{n} чел.',
    'Хотите рассчитать цену?': 'Хотите рассчитать цену?',
    'Воспользуйтесь нашим калькулятором: выберите музей, объект и количество билетов — сумма посчитается по вашему прайс-листу.': 'Воспользуйтесь нашим калькулятором: выберите музей, объект и количество билетов — сумма посчитается по вашему прайс-листу.',
    'Открыть калькулятор': 'Открыть калькулятор',
    'Изменить номер': 'Изменить номер',
    'Изменить номер лицензии': 'Изменить номер лицензии',
    'Не удалось изменить номер лицензии. Попробуйте ещё раз.': 'Не удалось изменить номер лицензии. Попробуйте ещё раз.',
    'Расчёт по группам': 'Расчёт по группам',
    'Музеев в расчёте': 'Музеев в расчёте',
    'Итого по всем группам': 'Итого по всем группам',
    'Очистить расчёт': 'Очистить расчёт',
    'Группа добавлена в расчёт. Выберите следующий музей — количество билетов подставится прежнее.': 'Группа добавлена в расчёт. Выберите следующий музей — количество билетов подставится прежнее.',
    'чел.': 'чел.',
    'Убрать': 'Убрать',
    'Вместе с добавленными группами ({n})': 'Вместе с добавленными группами ({n})',
    'Расчёт стоимости': 'Расчёт стоимости',
    'Заголовок документа': 'Заголовок документа',
    'Не удалось подготовить файл. Попробуйте ещё раз.': 'Не удалось подготовить файл. Попробуйте ещё раз.',
    'доставка': 'доставка',
    'Скачать расчёт': 'Скачать расчёт',
    'новое': 'новое',
    'Подача заявок по расчёту': 'Подача заявок по расчёту',
    'На каждый музей уйдёт отдельная заявка. Выберите время посещения и укажите данные гида.': 'На каждый музей уйдёт отдельная заявка. Выберите время посещения и укажите данные гида.',
    'На эту дату записи нет — измените дату в калькуляторе': 'На эту дату записи нет — измените дату в калькуляторе',
    'выберите время': 'выберите время',
    'это время больше недоступно, выберите другое': 'это время больше недоступно, выберите другое',
    'Отправлено заявок: {n}': 'Отправлено заявок: {n}',
    'Причина': 'Причина',
    'До сбоя в офис успели уйти заявки {list} — они уже в «Заказах», подавать их заново не нужно.': 'До сбоя в офис успели уйти заявки {list} — они уже в «Заказах», подавать их заново не нужно.',
    'Остальные музеи оставлены в расчёте — исправьте и отправьте заново.': 'Остальные музеи оставлены в расчёте — исправьте и отправьте заново.',
    'Успешно': 'Успешно',
    'Заявка не отправлена': 'Заявка не отправлена',
    'Заявка на эту дату не принимается: не раньше чем за {n} дн. — измените дату в калькуляторе': 'Заявка на эту дату не принимается: не раньше чем за {n} дн. — измените дату в калькуляторе',

    // Калькулятор стоимости лицензий и выбор калькулятора (27.10.2026).
    'Билеты, экскурсионное обслуживание и услуги по вашему прайс-листу. Расчёт можно скачать и сразу подать заявку.': 'Билеты, экскурсионное обслуживание и услуги по вашему прайс-листу. Расчёт можно скачать и сразу подать заявку.',
    'Выберите, что посчитать': 'Выберите, что посчитать',
    'Из них оплачивается в офисе': 'Из них оплачивается в офисе',
    'К выбору калькулятора': 'К выбору калькулятора',
    'К получению лицензий': 'К получению лицензий',
    'Расчёт стоимости заявки': 'Расчёт стоимости заявки',
    'Расчёт стоимости лицензий': 'Расчёт стоимости лицензий',
    'Не удалось получить цены. Попробуйте ещё раз.': 'Не удалось получить цены. Попробуйте ещё раз.',
    'Оплачивается в офисе': 'Оплачивается в офисе',
    'Отметьте музеи слева — здесь появится расчёт.': 'Отметьте музеи слева — здесь появится расчёт.',
    'Отметьте музеи — стоимость посчитается по ценам текущего сезона': 'Отметьте музеи — стоимость посчитается по ценам текущего сезона',
    'Очистить': 'Очистить',
    'Первичное получение (обучение)': 'Первичное получение (обучение)',
    'Продление и получение лицензий по ценам текущего сезона. Расчёт можно скачать и перейти к оплате.': 'Продление и получение лицензий по ценам текущего сезона. Расчёт можно скачать и перейти к оплате.',
    'Продление лицензии': 'Продление лицензии',
    'Сезон': 'Сезон',
    'Цены на этот сезон пока не заведены. Уточните стоимость по телефону {phone}.': 'Цены на этот сезон пока не заведены. Уточните стоимость по телефону {phone}.',
    'лицензий: {n}': 'лицензий: {n}',
    'Цены на сезон пока нет — уточните по телефону {phone}.': 'Цены на сезон пока нет — уточните по телефону {phone}.',

    // Договор при отметке «Согласие» (28.10.2026).
    'Вы согласились с условиями договора и подписали его {date} в {time}, нажав «Согласие».': 'Вы согласились с условиями договора и подписали его {date} в {time}, нажав «Согласие».',
    'Договор подписан и сохранён в «Настройках».': 'Договор подписан и сохранён в «Настройках».',
    'Договоры оказания услуг, которые вы подписали отметкой «Согласие» при оплате лицензий. Их можно открыть и скачать в любой момент.': 'Договоры оказания услуг, которые вы подписали отметкой «Согласие» при оплате лицензий. Их можно открыть и скачать в любой момент.',
    'Договоры подписаны и сохранены в «Настройках».': 'Договоры подписаны и сохранены в «Настройках».',
    'Не удалось сохранить договор. Попробуйте ещё раз.': 'Не удалось сохранить договор. Попробуйте ещё раз.',
    'Подписанных договоров пока нет. Они появятся здесь, как только вы отметите «Согласие» на шаге оплаты продления или обучения.': 'Подписанных договоров пока нет. Они появятся здесь, как только вы отметите «Согласие» на шаге оплаты продления или обучения.',
    'После отметки «Согласие» договор сохранится в «Настройках»: его можно открыть и скачать в PDF в любой момент.': 'После отметки «Согласие» договор сохранится в «Настройках»: его можно открыть и скачать в PDF в любой момент.',
    'После отметки «Согласие» договоры сохранятся в «Настройках»: их можно открыть и скачать в PDF в любой момент.': 'После отметки «Согласие» договоры сохранятся в «Настройках»: их можно открыть и скачать в PDF в любой момент.',
    'Согласие: я принимаю условия договора возмездного оказания услуг': 'Согласие: я принимаю условия договора возмездного оказания услуг',
    'Согласие: я принимаю условия договоров возмездного оказания услуг': 'Согласие: я принимаю условия договоров возмездного оказания услуг',
    'Сохраняем договор…': 'Сохраняем договор…',
    'ожидает оплаты': 'ожидает оплаты',
    'от {date}': 'от {date}',

    // Расчёт стоимости: радиогид/аудиогид, итоги в множественных заявках (30.10.2026)
    'Что считаем': 'Что считаем',
    'Заявка в музей': 'Заявка в музей',
    'Радиогид в город': 'Радиогид в город',
    'Радиогид в музей': 'Радиогид в музей',
    'Выберите музей — расчёт появится здесь': 'Выберите музей — расчёт появится здесь',
    'Укажите количество аппаратов': 'Укажите количество аппаратов',
    'Для этой услуги цены в прайс-листе нет. Сумму рассчитает менеджер после подачи заказа.': 'Для этой услуги цены в прайс-листе нет. Сумму рассчитает менеджер после подачи заказа.',
    'Заказать радиогид / аудиогид': 'Заказать радиогид / аудиогид',
    'В расчёте есть заказ радиогида или аудиогида: такие заказы подаются в разделе «Радиогид / Аудиогид», заявки в музеи — из расчёта без него.': 'В расчёте есть заказ радиогида или аудиогида: такие заказы подаются в разделе «Радиогид / Аудиогид», заявки в музеи — из расчёта без него.',
    'Доставка': 'Доставка',
    'за пределами КАД': 'за пределами КАД',
    'в пределах КАД': 'в пределах КАД',
    'доставка в пределах КАД': 'доставка в пределах КАД',
    'Аппараты': 'Аппараты',
    'аппараты': 'аппараты',
    'Заказ добавлен в расчёт.': 'Заказ добавлен в расчёт.',
    'оценено музеев: {n} из {total}': 'оценено музеев: {n} из {total}',
    'оценено групп: {n} из {total}': 'оценено групп: {n} из {total}',
    'Кол-во аппаратов': 'Кол-во аппаратов',
    'Оформить доставку (услуга платная)': 'Оформить доставку (услуга платная)',
    'Доставка в пределах КАД': 'Доставка в пределах КАД',
    'Доставка за пределы КАД': 'Доставка за пределы КАД',
}
